const stickTopSentinelEl = document.createElement("div");
stickTopSentinelEl.style.height = "calc(var(--header-height) + 0.5rem)";
stickTopSentinelEl.style.position = "absolute";
document.body.appendChild(stickTopSentinelEl);

let ticking = false;
let animationId = null;

function isElementInViewport(el) {
  var top = el.offsetTop;
  var left = el.offsetLeft;
  var width = el.offsetWidth;
  var height = el.offsetHeight;

  while (el.offsetParent) {
    el = el.offsetParent;
    top += el.offsetTop;
    left += el.offsetLeft;
  }

  return (
    top < window.scrollY + window.innerHeight &&
    left < window.scrollX + window.innerWidth &&
    top + height > window.scrollY &&
    left + width > window.scrollX
  );
}

function minmax(min, max, num) {
  if (num < min) return min;
  if (num > max) return max;
  return num;
}

function updateStickyHeaders() {
  const tableEls = document.querySelectorAll("[data-js-perf-sticky-table]");
  const topDistance = stickTopSentinelEl.getBoundingClientRect().height;

  tableEls.forEach((tableEl) => {
    const tbodyEl = tableEl.querySelector("tbody");

    if (tbodyEl) {
      const tbodyHeight = tbodyEl.getBoundingClientRect().height;

      if (isElementInViewport(tableEl)) {
        const theadEl = tableEl.querySelector("thead");
        const boundaryTop = (tableEl.getBoundingClientRect().top - topDistance) * -1;
        const translateY = minmax(0, tbodyHeight, boundaryTop);

        // Use transform3d for hardware acceleration and smoother animations
        theadEl.style.transform = `translate3d(0, ${translateY.toFixed(2)}px, 0)`;
      }
    }
  });

  ticking = false;
}

window.addEventListener("scroll", () => {
  if (!ticking) {
    ticking = true;
    animationId = requestAnimationFrame(updateStickyHeaders);
  }
});

// Clean up animation frame on page unload
window.addEventListener("beforeunload", () => {
  if (animationId) {
    cancelAnimationFrame(animationId);
  }
});
